export function objectToFormData(obj) {
  const fd = new FormData();
  Object.entries(obj).forEach(item => item[1] && fd.append(item[0], item[1]));

  return fd;
}
